import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { CustomerComponent } from '../customer/customer.component';
import { CustomerLimitComponent } from '../customer-limit/customer-limit.component';
import { element } from 'protractor';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css']
})
export class CustomerListComponent implements OnInit {

  public menu_item_id = '7';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['acct_number', 'customer_name', 'customer_name_en', 'city_name', 'mobile', 'sales_invoice',
    'sales_detail', 'invoice', 'show_file', 'edit', 'del'];   // , 'limit'
  displayedColumns2 = ['acct_number', 'customer_name', 'customer_name_en', 'city_name', 'mobile'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<CustomerComponent>;
  addDialogRef2: MatDialogRef<CustomerLimitComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'customer', 'customer_name': '', 'acct_number': '', 'mobile': '',
    'phone1': '', 'tax_no': '', 'represent1': '', 'represent1_mobile': '', 'branch_id': '-1',
    'title': 'قائمة العملاء'
  };

  branchList = [];

  Customer_List; Car_List; Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Customer_List').subscribe((res: string) => {
      this.Customer_List = res;
    });
    this.model['title'] = this.Customer_List;

    translate.get('Car_List').subscribe((res: string) => {
      this.Car_List = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {

    let href = this.router.url;
    let urlParts = href.split("/");
    if (urlParts[2] == '8') {
      this.menu_item_id = '7';
    }
    else if (urlParts[2] == '12') {
      this.menu_item_id = '77';
    }


    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);


    if (this.menu_item_id == '77') {
      this.displayedColumns = ['plate_number', 'plate_number_en', 'represent1', 'car_type', 'car_model', 'car_color',
        'sales_detail', 'invoice', 'show_file', 'limit', 'edit', 'del'];
      this.displayedColumns2 = ['plate_number', 'plate_number_en', 'represent1', 'car_type', 'car_model', 'car_color'];
      this.model['title'] = this.Car_List;
    }

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.push({ 'branch_id': '0', 'branch_name': 'مشترك لجميع الفروع', 
            'branch_name_en': 'Common to all branches' });
      
        this.branchList.unshift({ 'branch_id': '-1', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  search() {

    let condition = "";

    if (this.model['customer_name'] != '')
      condition = " AND (`customer`.`customer_name` LIKE '%" + this.model['customer_name'] +
        "%' OR `customer`.`customer_name_en` LIKE '%" + this.model['customer_name'] + "%')";

    if (this.menu_item_id == '7' && this.model['acct_number'] != '')
      condition += " AND `customer`.`acct_number` LIKE '%" + this.model['acct_number'] + "%'";

    if (this.menu_item_id == '7' && this.model['mobile'] != '')
      condition += " AND `customer`.`mobile` LIKE '%" + this.model['mobile'] + "%'";

    if (this.menu_item_id == '7' && this.model['phone1'] != '')
      condition += " AND (`customer`.`phone1` LIKE '%" + this.model['phone1'] + "%' OR `customer`.`phone2` LIKE '%" + this.model['phone1'] + "%')";

    if (this.menu_item_id == '7' && this.model['tax_no'] != '')
      condition += " AND `customer`.`tax_no` LIKE '%" + this.model['tax_no'] + "%'";

    if (this.menu_item_id == '77' && this.model['represent1'] != '')
      condition += " AND `customer`.`represent1` LIKE '%" + this.model['represent1'] + "%'";

    if (this.menu_item_id == '77' && this.model['represent1_mobile'] != '')
      condition += " AND `customer`.`represent1_mobile` LIKE '%" + this.model['represent1_mobile'] + "%'";

    if (this.menu_item_id == '7' && this.model['branch_id'] != '-1')
      condition += " AND `customer`.`branch_id` = '" + this.model['branch_id'] + "'";

    else if (this.menu_item_id == '7' && this.model['branch_id'] == '-1') {
      let index = 1;
      let list_length = this.branchList.length;

      condition += " AND `customer`.`branch_id` IN (";
      this.branchList.forEach(element => {
        if (element.branch_id != '-1') {
          if (index < list_length)
            condition += " '" + element.branch_id + "',";
          else if (index == list_length)
            condition += " '" + element.branch_id + "'";
        }
        index++;
      });
      condition += ")";
    }

    let query;

    if (this.menu_item_id == '7') {
      query = "SELECT `customer`.*, " +
        "(CASE WHEN `customer`.`city_id` != '0' THEN (SELECT `city_name` FROM `city` WHERE `city_id` = `customer`.`city_id`) ELSE '' END) AS `city_name`, " +
        "(CASE WHEN `customer`.`city_id` != '0' THEN (SELECT `country_id` FROM `city` WHERE `city_id` = `customer`.`city_id`) ELSE '0' END) AS `country_id` " +
        "FROM `customer` WHERE `customer`.`status` = '1'" + condition;
    }
    else {
      query = "SELECT `customer`.* FROM `customer` WHERE `customer`.`status` = '1'" +
        " AND `customer`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id + "'" + condition;
    }
    // console.log(query);
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];

        if (this.menu_item_id == '77') {
          this.dp.forEach(element => {
            element.plate_number = element.customer_name;
            element.plate_number_en = element.customer_name_en;
          });
        }

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

  }

  newCostumerEntry() {
    this.addDialogRef = this.dialog.open(CustomerComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['op_type'] == 'success') 
        //   this.search();
          // this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
      });
  }

  limit(row) {
    this.addDialogRef2 = this.dialog.open(CustomerLimitComponent, {
      hasBackdrop: false,
      data: {
        acct_number: row
      }
    });
    this.addDialogRef2
      .afterClosed()
      .subscribe(result => {
      });

  }

  invoice_list(row) {
    this.router.navigate(['sub_menu/1/invoice_list', { 'customer_id': row.customer_id, 'customer_name': row.customer_name }]);
  }

  editCustomer(row) {
    let dialog_data = [{
      'table_name': 'customer', 'customer_id': row.customer_id,
      'customer_name': row.customer_name,
      'customer_name_en': row.customer_name_en,
      'acct_number': row.acct_number,
      'national_id': row.national_id,
      'customer_category_id': row.customer_category_id,
      'city_id': row.city_id,
      'tax_no': row.tax_no,
      'address': row.address,
      'street_name': row.street_name,
      'additional_street_name': row.additional_street_name, 
      'building_number': row.building_number, 
      'additional_number': row.additional_number, 
      'neighbourhood': row.neighbourhood, 
      'postal_zone': row.postal_zone, 
      'state_of_city': row.state_of_city,
      'mobile': row.mobile,
      'phone1': row.phone1,
      'phone2': row.phone2,
      'fax': row.fax,
      'email': row.email,
      'represent1': row.represent1,
      'represent1_mobile': row.represent1_mobile,
      'represent2': row.represent2,
      'represent2_mobile': row.represent2_mobile,
      'customer_cr': row.customer_cr,
      'def_rep_no': row.def_rep_no,
      'claim_day': row.claim_day,
      'comment': row.comment,
      'key': 'customer_id',
      'flag': 'update',
      'car_type': row.car_type,
      'car_model': row.car_model,
      'car_color': row.car_color,
      'is_account': row.is_account,
      'branch_id': row.branch_id
    }, { 'country_id': row.country_id }];

    this.addDialogRef = this.dialog.open(CustomerComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
          // this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
      });
  }

  delCustomer(row) {
    if (confirm(this.Del_Msg)) {

      let values = [{ 'table_name': this.model['table_name'], 'customer_id': row.customer_id },
        { 'table_name': 'sub_acct', 'acct_number': row.acct_number }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
            // this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  print() {

    let html_data = '<table cellpadding="8" cellspacing="0">';
    if (this.menu_item_id == '7')
      html_data += '<tr><td width="33%"> ' + this.Customer_List + ' </td></tr>';
    else
      html_data += '<tr><td width="33%"> ' + this.Car_List + ' </td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('customer_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');

  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
